module.exports = __webpack_public_path__ + "2c545fe1f0ffbd5a599c77a744bfd7d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logo.png
// module id = 3kNX
// module chunks = 5